export default __webpack_public_path__ + "static/media/blue_body.9b5a3379.png";